module.exports = __webpack_public_path__ + "static/ctaBackground-9d9d1e7628798a23facbec84f446ee95.svg";